export default __webpack_public_path__ + "static/media/photo--sm--kickoff2.79a7eec1.jpg";